import styled from "styled-components/macro";

// Keep the text column identical while a reply moves from activity to answer.
export const AssistantMessageFrame = styled.div`
  align-self: flex-start;
  box-sizing: border-box;
  width: 92%;
  padding: ${({ theme }) => theme.resolve("spacing_lg")}
    ${({ theme }) => theme.resolve("spacing_xl")};
  border: ${({ theme }) => theme.resolve("border_md")} solid transparent;
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  line-height: 21px;
`;
